import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight, faCircleInfo} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useAddBannerMutation } from "../../../../Services/HomeAPI";
import { useNavigate } from "react-router-dom";

function AddCategory() {
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState(null);
  const [isActive, setIsActive] = useState(1);
  const [buttonText, setButtonText] = useState("");
  const [buttonIsActive, setButtonIsActive] = useState(1);
  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState(null);
  const [buttonURL, setButtonURL] = useState("");
  const [addBanner, { isLoading }] = useAddBannerMutation();

  const validateForm = () => {
    let newErrors = {};
    if (!title.trim()) newErrors.title = "Title is required";
    if (!description.trim()) newErrors.description = "Description is required";
    if (!image) newErrors.image = "Image is required";
    if (!buttonText.trim()) newErrors.buttonText = "Button text is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("image", image);
    formData.append("is_active", isActive);
    formData.append("button_text", buttonText);
    formData.append("button_url", buttonURL);
    formData.append("button_is_active", buttonIsActive);

    try {
      await addBanner(formData).unwrap();
      alert("Banner added successfully!");
      setTitle("");
      setDescription("");
      setImage(null);
      setIsActive(1);
      setButtonText("");
      setButtonIsActive(1);
      setErrors({});
      setApiError(null);
      navigate("/home-banner-list");
    } catch (error) {
      setApiError(error.data?.message || "Something went wrong");
    }
  };

  return (
    <div>
      <h3>Add Banner</h3>
      <div className="breadcrum mb-4">
        <p>
          <Link to="/home-banner-list">
            <span>Banner</span>
          </Link>
          <FontAwesomeIcon icon={faAngleRight} className="mx-2" />
          <span className="active-link">Add</span>
        </p>
      </div>
      <div className="content-wrapper">
        <form onSubmit={handleSubmit} encType="multipart/form-data">
          <div className="row">
            <div className="col-md-6">
              <div className="mb-4 text-start">
                <div>
                  <label className="me-3">
                    <input
                      type="radio"
                      name="isActive"
                      value={1}
                      checked={isActive === 1}
                      onChange={() => setIsActive(1)}
                    /> Show
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="isActive"
                      value={0}
                      checked={isActive === 0}
                      onChange={() => setIsActive(0)}
                    /> Hide
                  </label>
                  <div className="tooltip-container">
                    <FontAwesomeIcon
                      icon={faCircleInfo}
                      className="text-warning mx-2"
                      style={{ cursor: "pointer" }}
                    />
                    <div className="tooltip">Show/Hide the Banner section</div>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="col-md-6">
              <div className="mb-4 text-start">
                <label className="form-label">Title</label>
                <input
                  type="text"
                  className="form-control"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
                {errors.title && <p className="text-danger">{errors.title}</p>}
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-4 text-start">
                <label className="form-label">Image</label>
                <input
                  type="file"
                  className="form-control"
                  onChange={(e) => setImage(e.target.files[0])}
                />
                {errors.image && <p className="text-danger">{errors.image}</p>}
              </div>
            </div>
            <div className="col-md-12">
              <div className="mb-4 text-start">
                <label className="form-label">Description</label>
                <textarea
                  className="form-control"
                  rows={4}
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
                {errors.description && (
                  <p className="text-danger">{errors.description}</p>
                )}
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-4 text-start">
                <label className="form-label">Button Label  <div className="tooltip-container">
                    <FontAwesomeIcon
                      icon={faCircleInfo}
                      className="text-warning mx-2"
                      style={{ cursor: "pointer" }}
                    />
                    <div className="tooltip">Button text</div>
                  </div></label>
                <input
                  type="text"
                  className="form-control"
                  value={buttonText}
                  onChange={(e) => setButtonText(e.target.value)}
                />
                {errors.buttonText && (
                  <p className="text-danger">{errors.buttonText}</p>
                )}
              </div>
            </div>
            <div className="col-md-6 d-flex align-center">
              <div className="mb-4 text-start">
                <div>
                  <label className="me-3">
                    <input
                      type="radio"
                      name="buttonIsActive"
                      value={1}
                      checked={buttonIsActive === 1}
                      onChange={() => setButtonIsActive(1)}
                    /> Show
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="buttonIsActive"
                      value={0}
                      checked={buttonIsActive === 0}
                      onChange={() => setButtonIsActive(0)}
                    /> Hide
                  </label>
                  <div className="tooltip-container">
                    <FontAwesomeIcon
                      icon={faCircleInfo}
                      className="text-warning mx-2"
                      style={{ cursor: "pointer" }}
                    />
                    <div className="tooltip">Enable/Disable the button</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-4 text-start">
                <label className="form-label">Button URL  <div className="tooltip-container">
                    <FontAwesomeIcon
                      icon={faCircleInfo}
                      className="text-warning mx-2"
                      style={{ cursor: "pointer" }}
                    />
                    <div className="tooltip">Link to the corresponding page</div>
                  </div></label>
                <input
                  type="url"
                  className="form-control"
                  value={buttonURL}
                  onChange={(e) => setButtonURL(e.target.value)}
                />
                {errors.buttonURL && (
                  <p className="text-danger">{errors.buttonURL}</p>
                )}
              </div>
            </div>
            
          </div>
          {apiError && <p className="text-danger text-center">{apiError}</p>}
          <button
            type="submit"
            className="btn btn-primary"
            disabled={isLoading}
          >
            {isLoading ? "Submitting..." : "Submit"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default AddCategory;
